module.exports = __webpack_public_path__ + "img/booking-stall-icon.35a20e1d.svg";